var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyStateFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.865 29.865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.385 30.635V38.885C33.385 40.4038 32.1538 41.635 30.635 41.635H5.885C4.36622 41.635 3.135 40.4038 3.135 38.885V5.885C3.135 4.36622 4.36622 3.135 5.885 3.135H12.9534",
    stroke: "currentColor",
    strokeWidth: 6.27,
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.865 13.365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.135 19.635L19.635 3.135H5.885C4.36622 3.135 3.135 4.36622 3.135 5.885V44.385C3.135 45.9038 4.36622 47.135 5.885 47.135H33.385C34.9038 47.135 36.135 45.9038 36.135 44.385V19.635ZM19.635 3.135V18.535C19.635 19.1425 20.1275 19.635 20.735 19.635H36.135",
    stroke: "currentColor",
    strokeWidth: 6.27,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateFiles);
export default __webpack_public_path__ + "static/media/Empty_state_files.0dc143a997131a18a1c1b11fcecbf8b6.svg";
export { ForwardRef as ReactComponent };